import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import { MarketProvider } from './contexts/MarketContext';
import './index.css';
import './i18n/config';

// Load brand-specific theme CSS based on market
const marketId = import.meta.env.VITE_MARKET || 'finland';
if (marketId === 'bangladesh') {
  import('./brands/posterden/theme.css');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <MarketProvider>
        <App />
      </MarketProvider>
    </HelmetProvider>
  </React.StrictMode>,
);





